// 🌦️🕯️ House day-part bands — HOUSE_AMBIENCE_TRIO_SPEC_2026_09_15 §3 (Lane B,
// bands RULED 09-15). ONE pure reader for "what part of the house day is it",
// consumed by HouseAmbientLayers (wash + glow modulation) and, later, the
// /room per-room recipes (ROOM_CAMERA_SPEC §4).
//
// Input is the SERVER's Phoenix house hour (house.circadian.clock.hour — the
// one-clock doctrine: never derive house time from the viewer's Date). This
// module never reads Date, never touches state, and returns null on anything
// that is not a real hour, so a non-house payload renders nothing.
//
// mult scales the base 0.10 wash opacity (ceiling 0.2 applied by the caller);
// glowMod scales the TV-glow strength (night strongest — the ruled ambient
// spill is "loudest at night, near-invisible at midday").
// Gate: src/utils/housePartOfDay.test.js.

export const HOUSE_DAY_BANDS = [
  { name: 'night',   from: 22, to: 5,  wash: '#26355f', mult: 1.25, glowMod: 1.0 },
  { name: 'dawn',    from: 5,  to: 8,  wash: '#e08a5a', mult: 0.9,  glowMod: 0.5 },
  { name: 'morning', from: 8,  to: 11, wash: '#dfe8ef', mult: 0.5,  glowMod: 0.25 },
  { name: 'midday',  from: 11, to: 16, wash: '#f2ecd9', mult: 0.25, glowMod: 0.15 },
  { name: 'golden',  from: 16, to: 19, wash: '#e2a44b', mult: 1.0,  glowMod: 0.55 },
  { name: 'dusk',    from: 19, to: 22, wash: '#5d4a85', mult: 1.1,  glowMod: 0.85 },
];

export function bandForHour(hour) {
  if (typeof hour !== 'number' || !Number.isFinite(hour) || hour < 0 || hour >= 24) return null;
  return HOUSE_DAY_BANDS.find((b) => (
    b.from < b.to ? (hour >= b.from && hour < b.to) : (hour >= b.from || hour < b.to)
  )) || null;
}

// 😴 The ASLEEP status line under a resident's name (09-25, Nina: "hard to see
// when the residents are sleeping"). It was white at ~0.38-0.42 alpha, which
// measured 2.7-2.8:1 on the chat card in four rooms (real page, the card is the
// same brown everywhere). Moonlight lavender says "night" by its HUE instead of
// by fading out: 4.85-5.25:1 on that card, just under the awake green
// (5.0-5.4:1), so asleep still reads a notch quieter. ONE value for both
// surfaces: GameStepPage's LocalStatusLine and the LocalsDossier cards.
// Gate: housePartOfDay.test.js (the contrast floor + both call sites).
export const ASLEEP_LINE_COLOR = '#c4bfe0';

// 👥 YOUR status line on YOUR own message (10-06, Nina: "it's hard to see the new
// status text on human user messages", then "lets do C"). Your own bubble is the
// theme accent (the House: #C4956A, measured rgb(195,149,106) in her screenshot),
// where the awake green measured 1.65:1. Option C: the line takes the bubble's
// own light text (a notch brighter than the time's 0.7), and the green moves into
// a small ringed dot in front. Every dark bubble keeps the green line.
// Gate: statusLineOwnBubble.test.js (the real LocalStatusLine, lifted and rendered).
export const OWN_BUBBLE_STATUS_COLOR = 'rgba(255,255,255,0.9)';
